import React from 'react'
import { TableHeaderRowProps } from 'react-virtualized'
import styled from 'styled-components'

const Wrapper = styled.div`
  border-bottom: 2px solid #ebeff2;
  border-top: 1px solid #ebeff2;
  display: flex;
  padding: 5px;
  align-items: center;
  font-weight: bold;
  text-transform: uppercase;
`

interface THeaderRow extends TableHeaderRowProps {
  key?: string
}

const HeaderRow = (props: THeaderRow): React.ReactElement => {
  const { columns, key, className, style } = props
  return (
    <Wrapper style={style} key={key} className={`${className}`}>
      {columns}
    </Wrapper>
  )
}

export default HeaderRow
